import { useEffect, useState } from "react";

// Nach einem Einspielen (06.10.2026, Ralph): Statt still mit der alten Seite weiterzuarbeiten,
// erscheint "Neue Version – bitte neu laden". Vergleicht das geladene Programm (main.<hash>.js)
// mit dem aktuellen auf dem Server (asset-manifest.json, ohne Zwischenspeicher abgerufen).
// Geprueft wird beim Start, alle 5 Minuten und wenn das Fenster wieder nach vorne kommt.
const geladenesProgramm = () => {
  const s = Array.from(document.scripts).find((x) => /\/static\/js\/main\.[^/]+\.js$/.test(x.src || ""));
  return s ? new URL(s.src).pathname : null;
};

export const NeueVersionHinweis = () => {
  const [neu, setNeu] = useState(false);

  useEffect(() => {
    const aktuell = geladenesProgramm();
    if (!aktuell) return undefined; // Entwicklungsmodus: kein gebautes Programm
    let aus = false;
    const pruefen = async () => {
      try {
        const r = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" });
        if (!r.ok) return;
        const m = await r.json();
        const server = m?.files?.["main.js"];
        if (!aus && server && server !== aktuell) setNeu(true);
      } catch { /* offline: nichts anzeigen */ }
    };
    pruefen();
    const t = setInterval(pruefen, 5 * 60 * 1000);
    const sichtbar = () => { if (document.visibilityState === "visible") pruefen(); };
    window.addEventListener("focus", pruefen);
    document.addEventListener("visibilitychange", sichtbar);
    return () => { aus = true; clearInterval(t); window.removeEventListener("focus", pruefen); document.removeEventListener("visibilitychange", sichtbar); };
  }, []);

  if (!neu) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] bg-primary text-primary-foreground shadow-lg rounded-md px-4 py-3 flex items-center gap-3 max-w-[calc(100vw-2rem)]" data-testid="neue-version-hinweis">
      <span className="text-sm font-medium">Neue Version – bitte neu laden</span>
      <button type="button" onClick={() => window.location.reload()} className="px-3 py-1.5 text-sm font-semibold rounded-sm bg-white text-primary hover:bg-white/90" data-testid="btn-neu-laden">
        Neu laden
      </button>
    </div>
  );
};

export default NeueVersionHinweis;
